import React, { ElementType, createElement, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useThemeColors } from "../../Store/modules/theme";
import { Color } from "../../StyleSheet";
import { useLanguage } from "../../Store/modules/language";

export type TextProps = {
  elementType: ElementType;
  bold?: boolean;
  fontSize?: number | string;
  translatable?: boolean;
  children?: string | ReactNode;
  disabled?: boolean;
  center?: boolean;
  className?: string;
  textAlign?: string;
  fontWeight?: string | number;
  lineHeight?: number | string;
  dangerouslySetInnerHTML?: { __html: string | undefined };
  onClick?: () => void;
  color?: Color;
  _color?: string;
  hasUnderline?: boolean;
  lineThrough?: boolean;
  textDecorationColor?: string;
  textDirection?: "rtl" | "ltr";
  htmlFor?: string;
  style?: React.CSSProperties;
};

export const Text: React.FC<TextProps> = (props) => {
  const {
    elementType,
    children,
    lineHeight,
    disabled,
    center,
    className,
    dangerouslySetInnerHTML,
    onClick,
    fontSize,
    fontWeight,
    color = "text",
    translatable = true,
    _color,
    hasUnderline,
    lineThrough,
    textDecorationColor,
    textDirection,
    htmlFor,
    style,
  } = props;

  const { t } = useTranslation();
  const [theme] = useThemeColors();
  const { direction, locale } = useLanguage();

  //@ts-ignore
  const text = translatable ? t(children) : children;

  return createElement(
    elementType,
    {
      onClick,
      dangerouslySetInnerHTML,
      htmlFor,
      className: `${className ? className : ""}  ${onClick ? "pointer" : ""}`,
      style: {
        ...style,
        lineHeight,
        textAlign: center ? "center" : "",
        cursor: disabled ? "not-allowed" : undefined,
        direction: textDirection || direction,
        fontFamily: locale === "en" ? "Mulish, Estedad" : "Estedad, Mulish",
        color: _color ?? theme[color],
        fontSize,
        fontWeight,
        textDecoration: lineThrough
          ? `line-through ${textDecorationColor ? textDecorationColor : ""}`
          : hasUnderline
            ? "underline"
            : "",
      },
    },
    text,
  );
};
